module.exports = __webpack_public_path__ + "img/search.c087e16a.svg";